import * as CryptoJS from 'crypto-js';
import Data from "../../Data/Data.json"

export class Crypter{

  private static _key: string = Data.SecretKey.AesKey;
  private static _iv: string = Data.SecretKey.AesIv;

  public static encrypt(message: string){
    let key : CryptoJS.lib.WordArray  = CryptoJS.enc.Base64.parse(Crypter._key);
    let iv : CryptoJS.lib.WordArray = CryptoJS.enc.Base64.parse(Crypter._iv);
    let ciphertext = CryptoJS.AES.encrypt(message, key, {iv: iv}).toString();
    return ciphertext;
  }

  public static decrypt(message: string){
    let key : CryptoJS.lib.WordArray  = CryptoJS.enc.Base64.parse(Crypter._key);
    let iv : CryptoJS.lib.WordArray  = CryptoJS.enc.Base64.parse(Crypter._iv);
    let decryptedData = CryptoJS.AES.decrypt(message, key, {
      iv: iv
    });
    return decryptedData.toString( CryptoJS.enc.Utf8);
  }
}